import React from "react";
import { useAuthUser } from "@/hooks/auth/useAuth";
import { useTenant } from "../../contexts/TenantContext";
import { useLocation } from "react-router-dom";
import FloatingAgentCard from "../features/team/FloatingAgentCard";
import { TeamMember } from "../../api/teamMembers";

const ClaimedLeadCard: React.FC = () => {
  const user = useAuthUser();
  const { config } = useTenant();
  const location = useLocation();

  // Check if we're on the team page to avoid duplicate agent cards
  const isTeamPage = location.pathname.includes("/team/");

  // If no user or no claimed lead, or if we're on the team page, don't render anything
  if (!user || !user.claimedLead || isTeamPage) {
    return null;
  }

  // Get the primary color from the tenant config
  const primaryColor = config?.branding?.colors?.primary || "#2563eb";

  // Convert the claimedLead to the TeamMember format expected by FloatingAgentCard
  const teamMember: TeamMember = {
    id: user.claimedLead.id || "",
    organization_id: user.claimedLead.organization_id || "",
    email: user.claimedLead.email || "",
    // Handle both possible structures for name
    first_name:
      user.claimedLead.first_name ||
      ((user.claimedLead as any).name
        ? (user.claimedLead as any).name.split(" ")[0]
        : ""),
    last_name:
      user.claimedLead.last_name ||
      ((user.claimedLead as any).name
        ? (user.claimedLead as any).name.split(" ").slice(1).join(" ")
        : ""),
    // Handle both possible structures for phone
    phone_number:
      user.claimedLead.phone_number ||
      (user.claimedLead as any).phoneNumber ||
      "",
    // Include photo_url if available
    photo_url: (user.claimedLead as any).photo_url || "",
    // Include bio if available
    bio: (user.claimedLead as any).bio || "",
  };

  return (
    <FloatingAgentCard teamMember={teamMember} primaryColor={primaryColor} />
  );
};

export default ClaimedLeadCard;
